// Call Emissions Factors
import { apiAuth } from '../../utils/hooks';

const getAllProductReferences = (params, mode) => {
    return apiAuth(mode)
        .get('/carbon/products/references', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllProductCategories = (mode) => {
    return apiAuth(mode)
        .get('/carbon/user/product-categories')
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllMonetaryRatioCategories = () => {
    return apiAuth()
        .get('/carbon/monetary-ratios/categories')
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getOneEmissionFactor = (idEmission, mode) => {
    return apiAuth(mode)
        .get(`/carbon/emissionFactors/${idEmission}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllEmissionsFactors = (params, mode) => {
    return apiAuth(mode)
        .get('/carbon/emissionFactors', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getOneMonetaryRatio = (id, mode) => {
    return apiAuth(mode)
        .get(`/carbon/monetary-ratios/${id}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllMonetaryRatios = (params, mode) => {
    return apiAuth(mode)
        .get('/carbon/monetary-ratios', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const postCsvCatalog = (catalog, mode) => {
    return apiAuth(mode)
        .post('/carbon/products/catalog', catalog, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const postMatchingProduct = (newProduct, mode) => {
    return apiAuth(mode)
        .post('/carbon/products/references', newProduct)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchMatchingProduct = (productId, updatedProduct, mode) => {
    return apiAuth(mode)
        .patch(`/carbon/products/references/${productId}`, updatedProduct)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchMatchingCategory = (payload, mode) => {
    return apiAuth(mode)
        .patch(`/carbon/user/product-categories`, payload)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchGroupedMatchingProducts = (updatedProduct, mode) => {
    return apiAuth(mode)
        .patch('/carbon/products/references', updatedProduct)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export {
    getAllProductReferences,
    postCsvCatalog,
    postMatchingProduct,
    patchMatchingCategory,
    getAllProductCategories,
    getAllMonetaryRatioCategories,
    getAllEmissionsFactors,
    getOneMonetaryRatio,
    getAllMonetaryRatios,
    patchMatchingProduct,
    getOneEmissionFactor,
    patchGroupedMatchingProducts,
};
